import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Close from '@hellodarwin/icons/dist/icons/Close';
import { useTheme } from 'styled-components';
import { Burger, BurgerBar, getAppTheme } from './styles';
const NavigationBurger = ({ onClick, open }) => {
    const theme = useTheme();
    const color = getAppTheme(theme).burgerBarColor;
    return (_jsx(Burger, { onClick: onClick, "$open": open, children: open ? (_jsx(Close, { size: 26, style: { color } })) : (_jsxs(_Fragment, { children: [_jsx(BurgerBar, {}), _jsx(BurgerBar, {}), _jsx(BurgerBar, {})] })) }));
};
export default NavigationBurger;
